import { ComponentType } from '@angular/cdk/portal'

/**
 * Notificaciones con modal propio, por id: el slug si es masiva, la categoría
 * si es personal. El componente se carga solo cuando hace falta.
 *
 * Lo que no esté aquí y traiga `modalBody` abre el modal genérico.
 */
export const NOTIFICATION_MODALS: Record<string, () => Promise<ComponentType<unknown>>> = {
  'cena-modal': () => import('../components/cena-modal/cena-modal').then(m => m.CenaModal)
}

export function getModalComponent(id: string): Promise<ComponentType<unknown>> | undefined {
  return NOTIFICATION_MODALS[id]?.()
}
